import {useMutation} from "@tanstack/react-query";

import {editRepresentativeNoteMutationOptions} from "./edit-representative-note.mutation-options";

export function useEditRepresentativeNote(representativeId: string, noteId: number) {
  return useMutation(editRepresentativeNoteMutationOptions(representativeId, noteId));
}
